import { QueryParameterToolSet } from "./queryParameterTools";

export class Debug {
    private static _instance: Debug;
    
    private constructor() {
        const scopes: NodeListOf<HTMLElement> = document.querySelectorAll('.scope-dlp') as NodeListOf<HTMLElement>;

        if (!scopes) {
            return;
        }

        if (scopes.length > 0) {
            this.removeUnusedDebugElements(scopes);
        }

        this.bindEvents(scopes);
    }

    static get instance() {
        return this._instance || (this._instance = new this());
    }

    private bindEvents(scopes: NodeListOf<HTMLElement>): void {
        
        if(scopes.length > 0)
        {
            const scopesArray: Array<HTMLElement> = Array.prototype.slice.call(scopes);
            const lastScope: HTMLElement = scopesArray[scopesArray.length - 1];

            const button: Element = lastScope.querySelector('.dlp-debug-button');
            if (button) {
                button.addEventListener('click', ()=>{ this.toggleDebug(scopesArray); });
            }

            for (const scope of scopesArray)
            {
                const noCacheButton: Element = scope.querySelector('.dlp-debug-nocachebutton');
                if (noCacheButton) {
                    noCacheButton.addEventListener('click', this.redirectToNonCacheable);
                }
            }
        }
    }

    private toggleDebug(scopes: Array<HTMLElement>): void {
        for (const scope of scopes)
        {
            const elements: NodeListOf<Element> = scope.querySelectorAll('.debug-dlp');
            const elementsArray: Array<Element> = Array.prototype.slice.call(elements);

            for (let element of elementsArray) {
                element.classList.toggle('show');
            }
        }
    }

    private redirectToNonCacheable(eventContext): void {

        const disableCacheKey = eventContext.currentTarget.getAttribute("disablecachekey");
        if (disableCacheKey) {
            if (QueryParameterToolSet.instance) {
                let newAddress = window.location.href.split("?")[0] + QueryParameterToolSet.instance.append(disableCacheKey, "true", null);
                window.location.href = newAddress;
            }
        }
    }

    private removeUnusedDebugElements(scopes: NodeListOf<HTMLElement>): void {
        // during dlp grid cration we have debug bar for each grid element.
        // It is not needed. Only first one can stay and doo all the job.
        const scopesArray: Array<HTMLElement> = Array.prototype.slice.call(scopes);
        
        const lastIndex: number = scopesArray.length - 1;
        let dlpNavigationKey: string = "";

        for (let i: number = 0; i <= lastIndex; i++) {
            const scope: HTMLElement = scopesArray[i];
            const debugBarElement: HTMLElement = scope.querySelector('.debuginfo');
            const testButtonsContainer: HTMLElement = scope.querySelector('.test-buttons-container');

            if (!debugBarElement && !testButtonsContainer) {
                continue;
            }

            if (lastIndex === i) {

                let result: string = "NavKey: ";
                if (dlpNavigationKey.length > 0) {
                    result += dlpNavigationKey + ", " + testButtonsContainer.querySelector('.dlp-NavigationKey').textContent;
                } else {
                    result += testButtonsContainer.querySelector('.dlp-NavigationKey').textContent;
                }

                testButtonsContainer.querySelector('.dlp-NavigationKey')
                    .textContent = result;
            }
            else {

                if (dlpNavigationKey.length === 0) {
                    dlpNavigationKey += " " + testButtonsContainer.querySelector('.dlp-NavigationKey').textContent;
                }
                else {
                    dlpNavigationKey +=
                        ", " + testButtonsContainer.querySelector('.dlp-NavigationKey').textContent;
                }

                

                scope.removeChild(debugBarElement);
                scope.removeChild(testButtonsContainer);
            }                
        }
    }
}

Debug.instance;
